export type PaymentMethodCodeType = (typeof PaymentMethodCodeType)[keyof typeof PaymentMethodCodeType];
export const PaymentMethodCodeType = {
  /**決済手段区分:クレジットカード決済* */
  CREDIT_CARD_PAYMENT: '001',
  /**決済手段区分:コンビニ支払い* */
  CONVENIENCE_STORE_PAYMENT: '021',
  /**決済手段区分:ネット振込(みずほ銀行)* */
  ONLINE_TRANSFER_MIZUHO_BANK: '060',
  /**決済手段区分:ネット振込(三井住友銀行)* */
  ONLINE_TRANSFER_SUMITOMO_MITSUI_BANKING_CORPORATION: '069',
  /**決済手段区分:ネット振込(三菱UFJ銀行)* */
  ONLINE_TRANSFER_MUFG_BANK_LTD: '061',
  /**決済手段区分:ネット振込(ゆうちょ銀行)* */
  ONLINE_TRANSFER_JAPAN_POST_BANK: '063',
} as const;
